import { IFilterItem } from '@/constants/types';

export const quickFilters: IFilterItem[] = [
	{
		id: 'search',
		displayName: 'Search',
		placeHolder: 'Search',
		controller: 'text'
	}
];

export const menuFilters: IFilterItem[] = [
	{
		id: 'department',
		displayName: 'Department',
		controller: 'radio-list-column',
		controllerItems: [
			{ value: 'Womenswear', label: 'Womenswear' },
			{ value: 'Menswear', label: 'Menswear' }
		]
	}
];
